
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke351aRequest, Sgke351aResponse, Sgke351aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke351aService {

  /**
   * コンストラクタ
   * @param {Sgke351aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke351aService
   */
  constructor(
    public service: Sgke351aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE351A_供給再開作業割当初期表示API呼び出し
   * @param {Sgke351aRequest} request 
   * @returns {Observable<Sgke351aResponse>}
   * @memberof UsedSgke351aService
   */
  public doSgke351a(request: Sgke351aRequest): Observable<Sgke351aResponse> {
    return this.service.sgke351aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE351A');
          return throwError(err.message);
        })
      );
  }

}
